import {
  Component,
  forwardRef,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import {
  ControlValueAccessor,
  FormBuilder,
  FormControl,
  NG_VALUE_ACCESSOR,
} from '@angular/forms';
import { AppConstants } from '@wz-constants';
import { debounceTime } from 'rxjs/operators';

@Component({
  selector: 'wz-immatriculation',
  templateUrl: './immatriculation.component.html',
  styleUrls: ['./immatriculation.component.scss'],
  standalone: false,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ImmatriculationComponent),
      multi: true,
    },
  ],
})
export class ImmatriculationComponent
  implements OnInit, ControlValueAccessor, OnChanges
{
  control: FormControl;
  isBadFormat!: boolean;
  @Input()
  value!: string;

  @Input()
  zipCode!: string;

  @Input()
  disabled!: boolean;
  constructor(private fb: FormBuilder) {
    this.control = this.fb.control('');
  }

  ngOnInit() {
    this.control.valueChanges
      .pipe(debounceTime(AppConstants.Delay.Fast))
      .subscribe((val) => {
        this.propagateChange(val);
      });
  }

  ngOnChanges(sc: SimpleChanges) {
    if (sc['value'] && sc['value'].currentValue) {
      this.control.setValue(this.value);
    }

    if (
      sc['zipCode'] &&
      sc['zipCode'].currentValue &&
      this.zipCode.length > 2
    ) {
      this.zipCode = this.zipCode.substr(0, 2);
    }
  }

  /** ControlValueAccessor implem */
  writeValue(value: string): void {
    this.control.setValue(value, { emitEvent: false });
  }

  propagateChange = (_: any) => {};

  registerOnChange(fn: (_: any) => void) {
    this.propagateChange = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
    this.disabled ? this.control.disable() : this.control.enable();
  }
  registerOnTouched(_fn: any): void {}
}
